export type AuditActionIntent =
  | "create"
  | "update"
  | "delete"
  | "chat"
  | "trigger"
  | "share"
  | "security"
  | "neutral";

export interface AuditActionMeta {
  label: string;
  verb: string;
  intent: AuditActionIntent;
}

const AUDIT_ACTION_META: Record<string, AuditActionMeta> = {
  "chat.query": { label: "Chat query", verb: "asked Brian a question", intent: "chat" },

  "user.created": { label: "User created", verb: "created a user", intent: "create" },
  "user.updated": { label: "User updated", verb: "updated a user", intent: "update" },
  "user.password_reset": { label: "Password reset", verb: "reset a user's password", intent: "security" },
  "user.deactivated": { label: "User deactivated", verb: "deactivated a user", intent: "delete" },
  "user.deleted": { label: "User deleted", verb: "deleted a user", intent: "delete" },

  "report_schedule.created": { label: "Report schedule created", verb: "created a report schedule", intent: "create" },
  "report_schedule.updated": { label: "Report schedule updated", verb: "updated a report schedule", intent: "update" },
  "report_schedule.deactivated": { label: "Report schedule deactivated", verb: "deactivated a report schedule", intent: "delete" },
  "report.triggered": { label: "Report triggered", verb: "triggered a report", intent: "trigger" },
  "subscription.created": { label: "Subscription added", verb: "added a report subscription", intent: "create" },
  "subscription.removed": { label: "Subscription removed", verb: "removed a report subscription", intent: "delete" },

  "user_report.created": { label: "Report created", verb: "created a report", intent: "create" },
  "user_report.updated": { label: "Report updated", verb: "updated a report", intent: "update" },
  "user_report.deleted": { label: "Report deleted", verb: "deleted a report", intent: "delete" },
  "user_report.shared": { label: "Report shared", verb: "shared a report", intent: "share" },
  "user_report.schedule_deleted": { label: "Report schedule deleted", verb: "deleted a report schedule", intent: "delete" },

  "dashboard.created": { label: "Dashboard created", verb: "created a dashboard", intent: "create" },
  "dashboard.updated": { label: "Dashboard updated", verb: "updated a dashboard", intent: "update" },
  "dashboard.deleted": { label: "Dashboard deleted", verb: "deleted a dashboard", intent: "delete" },
  "dashboard.shares_updated": { label: "Dashboard sharing updated", verb: "updated dashboard sharing", intent: "share" },
  "dashboard_tile.created": { label: "Tile created", verb: "created a dashboard tile", intent: "create" },
  "dashboard_tile.updated": { label: "Tile updated", verb: "updated a dashboard tile", intent: "update" },
  "dashboard_tile.deleted": { label: "Tile deleted", verb: "deleted a dashboard tile", intent: "delete" },

  "metric.created": { label: "Metric created", verb: "created a metric", intent: "create" },
  "metric.updated": { label: "Metric updated", verb: "updated a metric", intent: "update" },
  "metric.deleted": { label: "Metric deleted", verb: "deleted a metric", intent: "delete" },
};

function humanizeActionCode(action: string): string {
  const words = action.split(/[._]/).filter(Boolean);
  if (words.length === 0) return "Action";
  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function getAuditActionMeta(action: string): AuditActionMeta {
  const known = AUDIT_ACTION_META[action];
  if (known) return known;
  const label = humanizeActionCode(action);
  return { label, verb: label.toLowerCase(), intent: "neutral" };
}
